"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var layout = {
    menuItemHeight: 40,
    sidebarWidth: 200,
    sidebarWidthCollapsed: 80,
};
exports.default = layout;
